module.exports = __webpack_public_path__ + "img/demo-aidh.db803b6f.png";